import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { FormToolsService } from "@atenea-cms";

@Component({
  selector: "product-prominent-form",
  templateUrl: "./product-prominent-form.component.html",
  styleUrls: ["./product-prominent-form.component.scss"],
})
export class ProductProminentFormComponent {
  @Input() form: FormGroup;

  constructor(public ft: FormToolsService) {}
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/product-prominent-form/product-prominent-form.component.ts